/* app/js/src/components/calendar/expandable/calendar-expandable-signal-event/calendar-expandable-signal-event.component.scss */
.event-wrapper {
  background-color: #e2e8f1;
  width: 100%;
  height: 35px;
  margin-top: 5px;
}
.item {
  display: flex;
  position: relative;
  background-color: #e2e8f1;
  width: 100%;
  height: 35px;
  margin-top: 5px;
  align-items: center;
  font-family: "Open Sans", sans-serif;
}
.visibility-icon {
  position: absolute;
  left: -23px;
  cursor: pointer;
}
.event-icon {
  margin-left: 8px;
}
.item-title-text {
  font-size: 12px;
  margin-left: 8px;
}
.event-container {
  font-size: 11px;
}
.item-title-container {
  display: flex;
  flex-direction: row;
  flex-basis: 119px;
}
.item-name {
  flex-basis: 4vw;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  white-space: nowrap;
}
.start-time-container {
  display: flex;
  flex-basis: 90px;
}
.end-time-container {
  display: flex;
  flex-basis: 90px;
}
.duration-time-container {
  display: flex;
  flex-basis: 90px;
}
.offset-time-container {
  display: flex;
  flex-basis: 90px;
}
.time-display {
  position: relative;
  left: 5px;
}
.z {
  z-index: 1000;
}
.a {
  z-index: 500;
}
.right-items {
  display: flex;
  flex-direction: row;
  margin-left: auto;
  flex-basis: 100px;
}
.rule-item {
  margin-right: 16px;
  font-size: 12px;
  text-decoration-line: underline;
  color: #40c4ff;
}
.instance-item {
  margin-right: 21px;
  font-size: 12px;
  text-decoration-line: underline;
  color: #40c4ff;
}
.event-wrapper {
  background-color: #e2e8f1;
  width: 100%;
  height: 35px;
  margin-top: 5px;
}
.item {
  display: flex;
  position: relative;
  background-color: #e2e8f1;
  width: 100%;
  height: 35px;
  margin-top: 5px;
  align-items: center;
  font-family: "Open Sans", sans-serif;
}
.visibility-icon {
  position: absolute;
  left: -23px;
  cursor: pointer;
}
.event-icon {
  margin-left: 8px;
}
.item-title-text {
  font-size: 12px;
  margin-left: 8px;
}
.event-container {
  font-size: 11px;
}
.item-title-container {
  display: flex;
  flex-direction: row;
  flex-basis: 119px;
}
.time-display {
  position: relative;
  left: 5px;
}
.z {
  z-index: 1000;
}
.a {
  z-index: 500;
}
.picker-container {
  display: flex;
  flex-basis: 96px;
}
.edit-item {
  margin-right: 16px;
  font-size: 12px;
  text-decoration-line: underline;
  color: #40c4ff;
}
.trash-icon {
  cursor: pointer;
}
/*# sourceMappingURL=calendar-expandable-signal-event.component.css.map */
